import { Injectable } from '@angular/core';

import * as uuid from 'uuid';
import { PaymentContext } from '../value-objects/payment-context.model';
import { IPaymentDetails } from '../../../../interfaces/payment.interface';
import { Payment } from '../model/payment.model';
import { PaymentMapper } from '../mappers/payment.mapper';
import { DEFAULT_CURRENCY } from '../../../../../config/app.config';
import { PAYMENT_STATUS } from '../../../../enums/payment-status.enum';
import { EntryMapper } from '../../../entry/infrastructure/mapper/entry.mapper';
import { PAYMENT_TYPE } from '../../../../../shared/enums/payment-type.enum';

@Injectable({ providedIn: 'root' })
export class PaymentFactoryService {

  createPayment(context: PaymentContext, paymentDetails: IPaymentDetails): Payment {
    return this.buildCompletePayment(context, paymentDetails);
  }

  private buildCompletePayment(context: PaymentContext, paymentDetails: IPaymentDetails): Payment {
    const { paymentSummary, ticketSerie, entriesToPay, entriesRenderedAfterPayment } = paymentDetails;
    const { totalAmount, paymentMethod, paymentType } = paymentSummary;

    const { drawer, worker, organization } = context;
    const now = Date.now();

    return PaymentMapper.toModel({
      _id: uuid.v4(),
      amount: totalAmount,
      serie: ticketSerie ?? '',
      status: PAYMENT_STATUS.completed,
      payment_method: paymentMethod,
      payment_type: paymentType,
      created_at: now,
      paid_at: now,
      created_by: worker?.id ?? '',
      negocio_id: organization._id ?? '',
      divisa: organization.currency ?? DEFAULT_CURRENCY,
      cash_drawer_id: drawer?.id ?? '',
      cash_drawer_count_id: '',
      isProductPayment: paymentType === PAYMENT_TYPE.byProduct,
      paymentResume: paymentSummary,
      entries: entriesToPay.map(EntryMapper.toStorage),
      renderedEntries: entriesRenderedAfterPayment.map(EntryMapper.toStorage),
      operation: undefined,
    });
  }
}
